module.exports = __webpack_public_path__ + "img/page4.b5feba1f.png";